import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';
import { NgIf } from '@angular/common';
import {SpinnerIcon} from "@primeng/icons/spinner";
import { RentalContract } from '@modules/universal-billing/contract/contract.interface';

@Component({
  selector: 'app-detail-of-contract-details',
  standalone: true,
    imports: [
        TranslatePipe,
        MoneyFormatPipe,
        LocalizedDatePipe,
        NgIf
    ],
  templateUrl: './detail-of-contract-details.component.html',
  styleUrl: './detail-of-contract-details.component.scss'
})
export class DetailOfContractDetailsComponent {
  data: InputSignal<RentalContract> = input();
  @Output() edit = new EventEmitter();

  onEdit(): void {
    this.edit.emit();
  }
}
